/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { AddressInfoDisplayStyles } from "@eisinc/Overrides/Components/AddressInfoDisplay";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface InfoDisplayStylesV2 {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    contentText?: TypographyProps;
}

export const infoDisplayStylesV2: InfoDisplayStylesV2 = {
    wrapper: {
        css: css`
            width: 100%;
            display: inline-block;
        `,
    },
    titleText: {
        as: "h2",
        weight: "bold",
        size: 14,
        css: css`
            display: inline;
            padding-right: 5px;
        `,
    },
    contentText: {
        size: 14,
        css: css`
            text-align: left;
            word-break: break-all;
        `,
    },
};

export const infoDisplayStylesTwoV2: InfoDisplayStylesV2 = {
    wrapper: {
        css: css``,
    },
    titleText: {
        as: "h2",
        size: 16,
        weight: "bold",
        css: css`
            margin-bottom: 5px;
        `,
    },
    contentText: {
        as: "h2",
        size: 14,
    },
};

const addressCommonValues = {
    size: 14,
};

export const addressStyles: AddressInfoDisplayStyles = {
    companyNameText: {
        ...addressCommonValues,
        weight: "normal",
    },
    attentionText: {
        ...addressCommonValues,
    },
    address1Text: {
        ...addressCommonValues,
    },
    address2Text: {
        ...addressCommonValues,
    },
    address3Text: {
        ...addressCommonValues,
    },
    address4Text: {
        ...addressCommonValues,
    },
    countryText: {
        ...addressCommonValues,
    },
    phoneText: {
        ...addressCommonValues,
    },
    faxText: {
        ...addressCommonValues,
    },
    emailText: {
        ...addressCommonValues,
    },
};
